import { Box } from '@mui/material';
import { IMachine } from 'types/interfaces/iMachine';
import EmptyState from '../../components/EmptyState';
import { ContainerProductionLine } from './elements';
import ProductionLine from './ProductionLine';

interface StatusOverviewProps {
  machines: {
    [key: string]: IMachine[];
  };
}

const StatusOverview = ({ machines }: StatusOverviewProps) => (
  <>
    {Object.keys(machines).length > 0 ? (
      <ContainerProductionLine>
        {Object.keys(machines).map((productionLine, idx) => (
          <Box key={productionLine} sx={{ mt: idx === 0 ? '2.5rem' : 0, ml: '3px' }}>
            <ProductionLine title={productionLine} machines={machines[productionLine]} />
          </Box>
        ))}
      </ContainerProductionLine>
    ) : (
      <EmptyState
        type="machines"
        action={{
          permissionBase: 'dashboard',
          permissionField: 'canEditMachines'
        }}
      />
    )}
  </>
);

export default StatusOverview;
